<template>
  <header class="main-header">
    <a class="logo" @click="sendMessage">
      <span class="logo-mini"><b>欢迎</b></span>
      <span class="logo-lg">
        <div class="row">
          <div class="col-xs-3">
            <img class="col-xs-6 img-circle" v-bind:src="logoContent" alt="User Image">
          </div>
          <div class="col-sm-9"><b>{{subHeadline}}</b></div>
        </div>
      </span>
    </a>
    <nav class="navbar navbar-static-top dt-nav" role="navigation">
      <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button" @click="offcanvas">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
      <div class="navbar-custom-menu title">{{headline}}</div>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <el-button @click="onCopy" icon="el-icon-copy-document" class="top-copy-btn dt-nav-btn" title="多开"></el-button>
          <li class="dropdown notifications-menu">
              <router-link :to="{path: '/message/advice'}" class="dropdown-toggle dt-nav-btn" data-toggle="dropdown" style="padding: 12px;" title="信息">
                <i class="fa fa-bell-o"></i>
                <span class="label label-warning" v-if="unReadCount != 0">{{unReadCount}}</span>
              </router-link>
          </li>
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img :src="logoContent" class="user-image" alt="User Image">
              <span class="hidden-xs"><b>{{loginName}}</b></span>
            </a>
            <ul class="dropdown-menu" style="background-color: #2F323E;">
              <li class="user-header">
                <img :src="logoContent" class="img-circle" alt="User Image">
                <p class="loginName" style="color: #fff;margin-top: -6px">{{loginName}}</p>
                <p class="role" style="color: #fff">{{role}}</p>
              </li>
              <li class="user-footer">
                <div class="pull-right">
                  <el-dropdown @command="command" trigger="click">
                    <el-button plain>
                      更多菜单
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="8222">前往隧道云平台</el-dropdown-item>
                      <el-dropdown-item command="8984">前往基坑平台</el-dropdown-item>
                      <!-- <el-dropdown-item command="token">令牌列表</el-dropdown-item> -->
                      <el-dropdown-item command="qrcode">
                        <el-tooltip effect="dark" content="点击加入企业微信接收消息" placement="left">
                          <span>企业微信二维码</span>
                        </el-tooltip>
                      </el-dropdown-item>
                      <el-dropdown-item command="editPassword">修改密码</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <a href="#" class="btn btn-default btn-center" @click="loginOut">退出</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <el-dialog
      title="扫一扫加入企业微信接收消息"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="30%">
      <div style="display: flex; flex-direction: column;align-items: center;">
        <img :src="companyLogo" alt="">
        <p style="color: red;">注意：该二维码只能一人使用，并且在本平台注册账号时的手机号码要和加入企业微信接收消息的手机号码一致，如果不一致，请修改本平台的手机号码再重新扫码加入。</p>
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <editPassWordDialog
      v-if="passWordDialog.show"
      :dialogRow="passWordDialog"
      @closeEditPasswordDialog="closeEditPasswordDialog"
    />
  </header>
</template>
<script>
  import GlobalEnum from '../../managers/enum/global-enum';
  import editPassWordDialog from '../main/account/components/editPassWordDialog.vue'
  import axios from "axios";
  export default{
    data () {
      return {
        account: {},
        loginName: '',
        role: null,
        avatar: null,
        welcomeL: '',
        title: '',
        unReadCount:'',
        logoContent: null,
        subHeadline: null,
        headline: null,
        logoShow: true,
        companyLogo: null,
        dialogVisible: false,
        passWordDialog: {
          show: false,
          data: {}
        }
      };
    },
    components: { editPassWordDialog },
    mounted () {
      let account = window.session.getObj(window.sessionKeys.ACCOUNT);
      this.account = account;
      this.companyLogo = window.mainConfig.companyLogo;
      this.initLogoInfo();

      this.avatar = window.mainConfig.avatar;
      this.welcomeL = window.mainConfig.welcomeL;
      this.title = window.mainConfig.title;

      this.loginName = account ? account.name : '默认用户';
      const roleObj = GlobalEnum.roleList.find(item => item.value === account.roleId);
      this.role = roleObj ? roleObj.text : '';
      window.mainConfig.http.getMessageLogCountByAccountId_A().then((response) => {
        if (typeof response.data[0] === 'undefined') {
          this.unReadCount = 0;
        } else {
          this.unReadCount = response.data[0].unReadCount;
        }
      }, (response) => {
      });

      // 下拉菜单点击时不隐藏
      $('.dropdown-menu').on('click', function(e) {
        e.stopPropagation();
      });
    },
    methods: {
      offcanvas() {
        if ($(document.body).width()>768) {
          this.logoShow = !this.logoShow;
          if (!this.logoShow) {
            $('.logo').animate({opacity:'0'});
            $('.logo').css('display','none');
            $('.dt-nav').animate({marginLeft: '0px'}, 'fast');
          }else {
            $('.logo').css('display','block');
            $('.logo').animate({opacity:'1'});

            $('.dt-nav').animate({marginLeft: '230px'});
          }
        }
      },
      onCopy() {
        window.open(window.location);
      },
      loginOut() {
        if(window.parent !== window) {
          const data = {
            type: 'LOGOUT'
          }
          window.parent.postMessage(data, 'http://localhost:5173');
          window.parent.postMessage(data, 'http://monitor.szdatie.com:10214');
        }else {
          window.mainConfig.http.logout().finally(() => {
            sessionStorage.clear();
            window.location.reload();
            this.$router.push({path: '/login'});
          });
        }
      },
      initLogoInfo(){
        window.mainConfig.http.getOrganizationRoleIdAndLogo_A().then((response) => {
          if(response.data[0]){
            this.logoContent =response.data[0].logoContent;
            this.subHeadline = response.data[0].subHeadline;
            this.headline = response.data[0].headline;
            if (this.logoContent === null || this.logoContent === "" || this.logoContent === 'data:image/png;base64,') {
              this.logoContent = this.avatar;
            }
            if (this.subHeadline === null) {
              this.subHeadline = this.welcomeL;
            }
            if (this.headline === null) {
              this.headline = this.title;
            }
          }
        },(response)=>{});
      },
      addWechaUser() {
        const { phone, name } = this.account;
        const wechatInfo = {
          userid: phone,
          name: name,
          mobile: phone
        }
        let alarmMessageUrl = window.mainConfig.alarmUrl;
        let instance = axios.create({
          baseURL:alarmMessageUrl
        });
        instance.post('/wechat/addWeChatUser', wechatInfo)
        .then((response) => {
          if (response.data.errcode == '0') {
            toastr.success("该用户微信号成功加入企业微信通讯录，扫码关注后将可随时接收平台消息推送");
            this.openDialog();
          } else if (response.data.errcode == '60102'|| response.data.errcode==='60104') {
            toastr.success("该用户微信号成功加入企业微信通讯录，扫码关注后将可随时接收平台消息推送");
            this.openDialog();
          } else {
            toast.alert({
              title: '提示信息！',
              type: 'error',
              text: '1、您的微信号关联平台的微信企业号失败,请一小时后再来点击修改你的个人信息(不用做修改)，再确认保存即可。' +
                    '2、微信企业号出错代号：'+response.data.errcode+',详情：'+response.data.meesage,
              onClose: function() {
              }
            })
          }
        }, (response) => {
          toast.alert({
            title: '提示信息！',
            type: 'error',
            text: '1、您的微信号关联平台的微信企业号失败,请一小时后再来点击修改你的个人信息(不用做修改)，再确认保存即可。' +
                 '2、微信企业号出错代号：'+response.data.errcode+',详情：'+response.data.meesage,
            onClose: function() {
            }
          })
        })
      },
      openDialog() {
        this.dialogVisible = true;
      },
      command(val) {
        if(val === '8222') {
          window.open('http://monitor.szdatie.com:8222');
        }else if(val === '8984') {
          window.open('http://monitor.szdatie.com:8984');
        }else if(val === 'token') {
          this.$router.push('/token/list');
        }else if(val === 'qrcode') {
          this.addWechaUser();
        }else {
          const userInfo = JSON.parse(sessionStorage.getItem('ACCOUNT'))
          const data = {
            accountName: userInfo.accountName
          }
          this.passWordDialog.data = data;
          this.passWordDialog.show = true;
        }
      },
      closeEditPasswordDialog(val) {
        if(val) {
          setTimeout(() => {
            window.mainConfig.http.logout().finally(() => {
              sessionStorage.clear();
              window.location.reload();
              this.$router.push({path: '/login'});
            });
          }, 3000)
        }
        this.passWordDialog.data = {};
        this.passWordDialog.show = false;
      },
      sendMessage() {
        const data = {
          type: 'BACK'
        }
        window.parent.postMessage(data, 'http://localhost:5173');
        window.parent.postMessage(data, 'http://monitor.szdatie.com:10214');
      }
    }
  };
</script>
<style type="scss" scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
  .main-header {
    width: 100%;
    position: fixed;
    background-color: #2f323e;
  }

  .main-header .logo {
    color:#ffffff;
  }

  .main-header .logo .logo-lg {
    display: inline-block;
  }

  .main-header .navbar .sidebar-toggle {
    color: #ffffff;
  }

  .main-header .navbar .navbar-custom-menu .nav li a.dropdown-toggle {
    background-color: #2f323e;
    color: #ffffff;
  }

  .main-header .navbar .navbar-custom-menu .nav li a.dropdown-toggle:hover {
    background-color: #ffffff;
    color: #2f323e;
  }
  .title{
    float:left;
    color:#ffffff;
    margin-left:10px;
    margin-top:13px;
    margin-bottom: 13px !important;
    font-size:1.8em;
    font-weight: 900;
    position: relative;
    font-family: inherit;
  }

  .navbar-custom-menu > .navbar-nav > li > .dropdown-menu {
    border: 1px solid #ddd;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }

  .navbar-nav > .user-menu > .dropdown-menu > li.user-header {
    border: 1px solid #ddd;
    border-radius: 3px;
  }

  .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p.loginName {
    font-size: 1.5em;
  }

  .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p.role {
    font-size: 1em;
  }

  .img-circle {
    width: 80px;
    height: 48px;
    margin-top: 2px;
    margin-bottom: 2px;
    cursor: pointer;
  }

  .width-minimun {
    min-width: 300px;
  }

  @media screen and (max-width: 768px) {
    #app .main-header .logo {
      display: none
    }

    .main-header .dt-nav .title{
      margin-top: 16px;
      font-size: 1.3em;
    }

    #message {
      display: block;
      width: 50px;
      height: 50px;
      background-color: yellow;
      border-radius: 15px;
      position: absolute;
      top: 0px;
      left: 0px;
    }
  }
  .top-copy-btn{
    background: rgb(47, 50, 62);
    border-radius: 0px;
    border: none;
    color: rgb(255, 255, 255);
    padding: 11px;
  }
  .top-copy-btn:hover{
    background: white;
    color: black;
  }
  .dt-nav-btn {
    font-size: 26px;
  }

</style>



// WEBPACK FOOTER //
// src/components/main/main-header.vue